import {
  getDecideOptions,
  transformDecision,
  type FeatureFlagResult,
  type FlagOptions,
} from './featureFlagDecision';
import { type FeatureFlag } from './featureFlags';
import { optimizelyClient } from './optimizelyClient';

export const decideFeatureFlag = <T extends FeatureFlag>(
  featureFlag: T,
  options?: FlagOptions,
): FeatureFlagResult<T> | null => {
  if (!optimizelyClient.isReady()) return null;

  // eslint-disable-next-line no-restricted-syntax
  const decision = optimizelyClient.decide(featureFlag.name, getDecideOptions(options));

  return transformDecision(featureFlag, decision);
};
